// @flow
import React from 'react';
import gql from 'graphql-tag';
import Breadcrumbs from '@homeaway/react-breadcrumbs';

import type {DestinationShape} from '../../queries/searchRequestQuery';

import './Breadcrumb.less';

type Props = {
    destination: ?DestinationShape
};

export const fragments = {
    SearchResult: gql`
        fragment DestinationBreadcrumbsSearchResult on SearchResult {
            destination(optimizedBreadcrumb: $optimizedBreadcrumb) {
                breadcrumbs {
                    name
                    url
                }
            }
        }
    `
};

export default (props: Props) => {
    const {breadcrumbs = []} = props.destination || {};
    return (
        !!breadcrumbs.length && (
            <div className="breadcrumb">
                <div className="breadcrumb__container">
                    <Breadcrumbs crumbs={breadcrumbs} isLastCrumbLinked />
                </div>
            </div>
        )
    );
};
